export const openCloseAddTweetModalAction = state => {
  return {
    type: "STATE_ADD_TWEET_MODAL",
    payload: state
  };
};
